import { render } from "./chatbot.vue?vue&type=template&id=afe80dcc&scoped=true"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"

import "./chatbot.vue?vue&type=style&index=0&id=afe80dcc&scoped=true&lang=css"
import "./chatbot.vue?vue&type=style&index=1&id=afe80dcc&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe80dcc"]])

export default __exports__